import { notifications } from '@mantine/notifications';

/**
 * Surfaces a Firestore `onSnapshot` subscription failure to the user via a
 * toast, and logs the underlying error for diagnostics. Every live-data hook
 * should wire this up as its `onSnapshot` error callback so a broken listener
 * (permission-denied, missing index, network drop, etc.) is never silently
 * swallowed — without it, dependent pages get stuck showing loading
 * skeletons forever with no indication anything went wrong.
 */
export const notifyLiveDataError = (context: string, error: unknown): void => {
  console.error(`[${context}]`, error);
  notifications.show({
    // Fixed id: if multiple listeners fail around the same time (e.g. a
    // shared network/auth blip), this replaces the existing toast instead
    // of stacking a pile of identical "connection error" notifications.
    id: 'live-data-error',
    color: 'red',
    message: 'Something went wrong loading live data. Please refresh the page.',
    title: 'Connection error',
  });
};
